import {
  Api,
  Application,
  CloudApp,
  Code,
  ColorPalette,
  DataBase,
  Rocket,
  Tools,
} from "@carbon/icons-react";
import Layout from "../../components/Layout";
import resumeSkills from "../../data/resumeSkills";
import { Paragraph, SectionTitle } from "../../styles";
import {
  CategoryHeader,
  CategoryIcon,
  CategoryTitle,
  ProfileLink,
  SkillCategory,
  SkillPill,
  SkillsContainer,
  SkillsList,
} from "./styles";

// Visual style per category; the skills themselves live in data/resumeSkills.js
// (shared with the PDF resume).
const categoryStyles = {
  "Mobile & Frontend": { icon: Application, color: "#0f62fe", bgColor: "rgba(148, 170, 212, 0.15)", textColor: "#78a9ff" },
  "State Management": { icon: CloudApp, color: "#8a3ffc", bgColor: "rgba(138, 63, 252, 0.15)", textColor: "#be95ff" },
  "Styling & Animation": { icon: ColorPalette, color: "#ff7eb6", bgColor: "rgba(255, 126, 182, 0.15)", textColor: "#ff7eb6" },
  "Backend & Data": { icon: DataBase, color: "#2ecc40", bgColor: "rgba(46, 204, 64, 0.15)", textColor: "#2ecc40" },
  "Integrations": { icon: Api, color: "#f1c21b", bgColor: "rgba(241, 194, 27, 0.15)", textColor: "#f1c21b" },
  "Testing & DevOps": { icon: Rocket, color: "#1192e8", bgColor: "rgba(51, 177, 255, 0.15)", textColor: "#33b1ff" },
  "Tools & Libraries": { icon: Tools, color: "#fa4d56", bgColor: "rgba(250, 77, 86, 0.15)", textColor: "#fa4d56" },
};

const defaultStyle = { icon: Code, color: "#525252", bgColor: "rgba(168, 168, 168, 0.15)", textColor: "#a8a8a8" };

const skillGroups = resumeSkills.map(({ category, items }) => ({
  name: category,
  skills: items,
  ...(categoryStyles[category] || defaultStyle),
}));

const Me = ({ user }) => {
  return (
    <Layout user={user}>
      <div>
        <SectionTitle>About Me</SectionTitle>
        <Paragraph>{user.basics.summary}</Paragraph>
      </div>
      <div>
        <SectionTitle>Skills</SectionTitle>
        <SkillsContainer>
          {skillGroups.map((category, index) => (
            <SkillCategory key={category.name} $index={index}>
              <CategoryHeader>
                <CategoryIcon $color={category.color}>
                  <category.icon size={18} />
                </CategoryIcon>
                <CategoryTitle>{category.name}</CategoryTitle>
              </CategoryHeader>
              <SkillsList>
                {category.skills.map((skill) => (
                  <SkillPill
                    key={skill}
                    $bgColor={category.bgColor}
                    $textColor={category.textColor}
                  >
                    {skill}
                  </SkillPill>
                ))}
              </SkillsList>
            </SkillCategory>
          ))}
        </SkillsContainer>
      </div>
      <div>
        <SectionTitle>Profiles</SectionTitle>
        <ul>
          {user.basics.profiles.map((profile, i) => (
            <ProfileLink key={profile.network}>
              {i !== 0 && " | "}
              <a href={profile.url} target="_blank" rel="noreferrer noopener">
                {profile.network}
              </a>
            </ProfileLink>
          ))}
        </ul>
      </div>
    </Layout>
  );
};

export default Me;
